import CreateInventoryReceivingShipmentButton from "./CreateInventoryReceivingShipmentButton";
export default CreateInventoryReceivingShipmentButton;
